import { Category } from '../types'

export const sumConfidences = (arr: Category[]) => arr.reduce((acc, current) => acc + current.confidence, 0)
    
        